@defer (when rates()) {
  <pp-scrollable-shadow>
    <div class="rates">
      <div class="rate">
        <span class="rate-title margin-auto">{{
          'exchangeRate.dialog.tab.rates.title' | translate
        }}</span>
        <pp-table
          class="exchange-table"
          [dataSource]="rates()"
          gridTemplateColumns="1fr 1fr 160px">
          <ng-template let-info #mobile>
            <section class="table-body">
              <div class="name">
                @if (selectCurrencyByCode(info.from)?.image?.url) {
                  <img
                    width="14"
                    height="14"
                    alt="Image"
                    [src]="selectCurrencyByCode(info.from)?.image?.url" />
                }
                <span>{{ info.from }}</span>
              </div>
              <div class="name justify-start">
                @if (selectCurrencyByCode(info.to)?.image?.url) {
                  <img
                    width="14"
                    height="14"
                    alt="Image"
                    [src]="selectCurrencyByCode(info.to)?.image?.url" />
                }
                <span>{{ info.to }}</span>
              </div>
              <div>
                <span class="justify-end">{{ info.value }}</span>
              </div>
            </section>
          </ng-template>
        </pp-table>
      </div>
    </div>
  </pp-scrollable-shadow>
} @placeholder (minimum 1ms) {
  <div class="loading">
    @for (column of array; track column) {
      <div class="pp-shimmer"></div>
    }
  </div>
} @error {
  <div class="pp-bold-12" translate="table.placeholder.notFound"></div>
}
